<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title" v-text="pageTitle"></label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span class="active">排期模板</span>|
					<span v-text="pageTitle"></span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap" :class="{ active: isExpanded }">

			<div class="table-wrap">
				<div class="action-bar">
					<el-button type="primary" size="mini" round @click="showDlg">新增排期</el-button>
					<el-popconfirm confirmButtonText='删除' title="确定批量删除吗？" @confirm="delItem">
						<el-button slot="reference" type="danger" size="mini" round plain>批量删除</el-button>
					</el-popconfirm>

				</div>
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column fixed="left" type="selection" width="50"></el-table-column>
					<el-table-column prop="templateNum" label="随访次数" width="100"></el-table-column>
					<el-table-column prop="templateContent" label="随访建议" show-overflow-tooltip></el-table-column>
					<el-table-column prop="dateNum" label="随访间隔" width="100"></el-table-column>
					<el-table-column prop="dateUnitName" label="间隔单位" width="100"></el-table-column>
					<el-table-column prop="reviser" label="更新人" width="100" show-overflow-tooltip></el-table-column>
					<el-table-column prop="date" label="更新时间" width="200"></el-table-column>
					<el-table-column fixed="right" label="操作" width="200">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="修改" placement="top" :enterable="false"><i class="el-icon-edit-outline"
										@click="showDlg(scope.row)"></i></el-tooltip>
								<el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delItem(scope.row)">
									<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i
											class="el-icon-delete"></i></el-tooltip>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
									v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
							</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<el-dialog class="template-form" :title="form.id > 0 ? '修改排期' : '新增排期'" width="600px" center
			:visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" :rules="dlg.rules" :model="form" label-width="120px">
				<el-form-item label="随访间隔" required>
					<el-col :span="12">
						<el-form-item prop="dateNum">
							<el-input size="small" v-model="form.dateNum" placeholder="请输入随访间隔"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="dateUnit">
							<el-select size="small" filterable clearable v-model="form.dateUnit" placeholder="请选择间隔单位">
								<el-option v-for="item in dateUnitList" :key="item.id" :label="item.text"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-form-item>
				<el-form-item label="随访建议" prop="templateContent">
					<el-input type="textarea" size="small" rows="10" resize="none" v-model="form.templateContent"
						maxlength="4000" :show-word-limit="true"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveTemplate">保 存</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import dayjs from 'dayjs';

export default {
	mixins: [mixin],
	data() {
		return {
			isExpanded: false,
			dlg: {
				active: false,
				rules: {
					dateNum: { required: true, message: '请输入随访间隔，必须是正整数', pattern: /^[1-9]\d*$/, trigger: 'blur' },
					dateUnit: { required: true, message: '请选择间隔单位', trigger: 'change' },
					templateContent: { required: true, message: '请输入随访建议内容', trigger: 'blur' }
				},
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				templateId: 0,
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				dateNum: '',
				dateUnit: '',
				templateContent: '',
				templateScheduleId: ''
			},
			dateUnitList: [
				{ 'id': '1', 'text': '日' },
				{ 'id': '2', 'text': '周' },
				{ 'id': '3', 'text': '月' },
				{ 'id': '4', 'text': '年' }
			]
		}
	},
	created() {
		let query = this.$route.query;
		if (query) {
			this.filter.templateId = query.templateId || '';
		}
		this.loadList();
	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getScheduleTemplateInfoById(this.filter);
			if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.templateScheduleInfoDetailVOS.forEach((item) => {
					item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
				})
				this.list.data = res.data.templateScheduleInfoDetailVOS;
			}
			this.pageTitle = res.data.templateScheduleName;
			// 修改页面title
			document.title = res.data.templateScheduleName;
			this.isLoading = false;
		},
		showDlg(item) {
			console.log(item)
			this.dlg.active = true;
			if (item && item.id > 0) {
				this.$nextTick(() => {
					this.$refs['form'].resetFields();
					this.form.id = item.id;
					this.form.templateScheduleId = this.$route.query.templateId;
					this.form.dateNum = item.dateNum;
					this.form.dateUnit = item.dateUnit;
					this.form.templateContent = item.templateContent;
					this.form.departmentId = item.departmentId;
				});
			} else {
				this.form.id = 0;
				this.form.templateScheduleId = this.$route.query.templateId;
				this.$nextTick(() => {
					this.$refs['form'].resetFields();
				});
			}
		},
		closeDlg() {
			this.dlg.active = false;
		},
		async saveTemplate() {
			let res;
			this.$refs['form'].validate(async (valid) => {
				if (valid) {
					if (this.form.id > 0) {
						res = await api.updateScheduleTemplateInfo(this.form);
					} else {
						// 后端问题，不能带这参数
						this.form.id = null;
						res = await api.addScheduleTemplateInfo(this.form);
					}
					if (res.code != 1000) {
						this.$message.error(res.message);
						return;
					}
					this.loadList();
					this.$message({ message: '保存成功', type: 'success' });
					this.closeDlg();
				}
			})
		},
		async delItem(item) {
			let res;
			if (this.isLoading) { return; }

			this.isLoading = true;
			console.log(item.id, '-------1', this.list.total);

			if (this.list.total == 1) {
				this.$message.error('无法删除                 最少保留一条随访');
				this.isLoading = false;
			} else {

				if (item && item.id > 0) {
					res = await api.delScheduleTemplateInfo({ ids: item.id });

				} else {
					// 批量删除
					if (this.multipleSelection.length == 0) {
						this.isLoading = false;
						return this.$message.warning('未选择任何数据');
					}
					console.log(this.multipleSelection.join(','), '====333');
					res = await api.delScheduleTemplateInfo({ ids: this.multipleSelection.join(',') });
				}
				if (res.code != 1000) {
					this.isLoading = false;
					return this.$message.error(res.message);
				}
				this.$message({ message: '已删除', type: 'success' });
				this.loadList();
			}
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		}
	}
}
</script>

<style lang="less">
@import '@/assets/style/var';

.template-form {
	.el-form {
		.el-textarea {
			width: 100%;
		}

		.el-input {
			width: 160px;
			margin-right: 20px;
		}

		.el-select {
			.el-input {
				width: 140px;
			}
		}

	}
}</style>
